/* eslint-disable complexity */
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { FormViewContent } from 'components/FormViewContent';
import { CTSUCardActions } from 'components';
import { ListItem, ListItemText } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { ValidatorForm, MUISelect, MUITextBox } from 'components/FormHelpers/FormInputs';
import { compose, withHandlers, withState } from 'recompose';
import { useCtxParseValue, getEmptyValue } from 'helpers';
import atoms from 'ctsutheme/components/atoms';
import molecules from 'ctsutheme/components/molecules';
import _ from 'lodash';
import { withChangeHandlers } from 'helpers/Change';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AppContext } from '@ctsu/loader';
import { bindLogger } from 'helpers/BindLogger';
import { getCheckValueForVerifiedByAction } from '../../../../actions/protocols/psrs';
import { SpecialRequirement } from './SpecialRequirement';
import {
  PSRMultilineTextControl,
  PSRDatePickerControl,
  PSRDropdownControl,
  PSRCheckValue
} from './psrselectors';


const { Divider, Typography, Tooltip } = atoms;
const { List, ListSubHeader } = molecules;

const styles = theme => ({
  textpsrField: {
    // textIndent: 5,
    // width: 350,
    // textAlign: 'left'
  },
  dateField: {
    width: 220,
    height: 33
  },
  editable: {
    // width: 70
  }
});

const SwitchCheckValue = (type) => ({
  INSTITUTION_ATTRIBUTE: 'LOV_PSR_INSTITUTION_ATTRIBUTE',
  PERSON_ATTRIBUTE: 'LOV_PSR_PERSON_ATTRIBUTE',
  MANUAL: 'LOV_PSR_MANUAL',
  RELATED_PROT_APPROVAL: 'LOV_PROTOCOL_LIST',
  SITE_REG: 'LOV_PROTOCOL_LIST',
  LINKED_ORG_PROVIDER: null,
  INTERNATIONAL: 'LOV_PSR_INTERNATIONAL',
  IMG_PROVIDER_CRED: 'LOV_PSR_IMG_PROVIDER_CRED',
  RT_PROVIDER_CRED: 'LOV_PSR_RT_PROVIDER_CRED',
  CREDENTIALS: 'LOV_PSR_CREDENTIALS',
  TRF_PROVIDER_CRED: 'LOV_TRF_PROVIDER_CRED'
})[type];

const useGetCheckValue = (type, key) => {
  // console.log(optionValues)
  const dispatch = useDispatch();
  const context = useContext(AppContext);
  const action = useMemo(() => bindActionCreators({ getCheckValueForVerifiedByAction }, dispatch), [dispatch]);
  const [optionValues, setOptionValues] = useState([]);
  // eslint-disable-next-line no-nested-ternary
  const sortArr = (arr) => arr.sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
  useEffect(() => {
    if (key) {
      bindLogger(action.getCheckValueForVerifiedByAction, context)(type).subscribe((data) => {
        setOptionValues(data.response[key])
      }, () => setOptionValues([]));
    } else {
      setOptionValues([]);
    }
  }, [key, action, context, type]);

  let resArr = []

  if (type === 'RELATED_PROT_APPROVAL') {
    resArr = _.map(_.cloneDeep(optionValues), (x) => _.assign(x, {
      label: `${x.value} - IRB Approval of ${x.value}`,
      desc: `IRB Approval of ${x.value}`
    }));
  } else
    if (type === 'SITE_REG') {
      resArr = _.map(_.cloneDeep(optionValues), (x) => _.assign(x, {
        label: `${x.value} - Site Reg. Approval for ${x.value}`,
        desc: `Site Reg. Approval for ${x.value}`
      }));
    } else {
      resArr = _.map(_.cloneDeep(optionValues), (x) => _.assign(x, {
        label: `${x.value} - ${x.label}`,
        desc: x.label
      }));
    }
  return sortArr(resArr);
};

const statusData = [
  { code: 'ACTIVE', value: 'Active' },
  { code: 'OBSOLETE', value: 'Obsolete' },
  { code: 'PROPOSED', value: 'Proposed' }
];

const psrTypeData = [
  { code: 'REQUIRED', value: 'Required' },
  { code: 'COLLECT', value: 'Collect' }
  // { code: 'INTERNAL', value: 'Internal' }
  // { code: 'DEFAULT', value: 'Default' }
];

export const EditPsrDetails = props => {
  const {
    data,
    state,
    setState,
    classes,
    closeEditPSR,
    versions,
    savePSRInfo,
    handleChange,
    handleDateChange,
    handleCheckValueChange,
    clearHandler,
    handleVerfiedByChange,
    handleVersionChange,
    deleteAffiliation,
    editMode,
    isNewpsr
  } = props;
  useEffect(() => {
    setState({
      ...data
    });
  }, [setState, data]);

  const [saveFlag, setSaveFlag] = useState(false);

  const {
    verifiedBy,
    code,
    comments,
    ctsuGeneralInstructions,
    description,
    esysStatus,
    verId,
    isEvalByGroup,
    numPersonRqdFulfillPsr,
    psrType,
    requiredByDate,
    source,
    websiteDescription,
    websiteInstructions,
    contactName,
    contactPhone,
    contactEmail,
    distributionEmail,
    psrId
  } = state || {};

  const { textpsrField } = classes;

  const { protocolPSRVerifiedBy } = useCtxParseValue('LOV_PSR_VERIFIED_BY');
  const { protocolPSRSource } = useCtxParseValue('LOV_PSR_SOURCE');
  const checkValueLovStr = SwitchCheckValue(verifiedBy);
  const checkValueParsedStr = useCtxParseValue(checkValueLovStr);
  const key = checkValueParsedStr && Object.keys(checkValueParsedStr)[0];
  // eslint-disable-next-line no-nested-ternary
  const checkValueOptions = useGetCheckValue(checkValueLovStr, key);
  const saveHandler = (event) => {
    savePSRInfo(state);
  };

  const loadAffiliation = () => {

    return (
      <>
        <Divider />
        <div className="mx-3">
          <SpecialRequirement
            psrData={state}
            tagId="newPsraffiandverifications"
            editAffiliation
            psrSplReqAffi={state.affiliations || []}
            disabled={!state.verifiedBy}
            psrId={null}
            deleteAffiliation={deleteAffiliation}
            onSave={null}
            disableCreate={setSaveFlag}
            editMode={editMode}
            setPsrData={setState}
            isNewpsr={isNewpsr}
          />
        </div>
      </>
    );
  }

  const isDisabled = (verifiedBy === 'SITE_DTL') || ['IRBA', 'IRB'].includes(code);

  return (
    <ValidatorForm onSubmit={saveHandler}>
      <PSRDropdownControl
        textValue="Verified BY"
        name="verifiedBy"
        psrProtocolData={protocolPSRVerifiedBy}
        handleDropdown={(e) => {
          handleVerfiedByChange(e);
          // settimeout is required to render on next loop.
          // otherwise the changes will not reflect in UI
          setTimeout(() => {
            handleChange({target: {value: undefined, name: 'numPersonRqdFulfillPsr'}})
          }, 0);
        }}
        value={getEmptyValue(verifiedBy)}
        validators={['required']}
        errorMessages={['Required Field']}
        isDisabled={isDisabled === true}
      />
      <Divider />
      <PSRCheckValue
        handleChange={handleCheckValueChange}
        checkValueOptions={checkValueOptions}
        value={getEmptyValue(code)}
        isDisabled={isDisabled === true || verifiedBy === 'LINKED_ORG_PROVIDER'}
      />
      <Divider />
      <PSRMultilineTextControl
        textpsrField={textpsrField}
        primaryText="Description"
        name="description"
        value={getEmptyValue(description)}
        onChange={handleChange}
        validators={description ? ['maxStringLength:250'] : []}
        errorMessages={['Crossed the maximum limit of 250 characters']}
        isDisabled={isDisabled === true}
      />
      <Divider />
      <FormViewContent
        primaryText="For Version Date"
        secondaryText={(
          <MUISelect
            value={verId}
            title="For Version Date"
            name="forVersionDate"
            validators={['required']}
            errorMessages={['Required Field']}
            onChange={handleVersionChange}
            disabled={isDisabled === true}
          >
            {_.map(versions.data, item => (
              <ListItem
                button
                value={item.verId}
                key={item.verId}
              >
                <ListItemText
                  primary={item.versionDate}
                  secondary={item.versionDesc}
                />
              </ListItem>
            ))}
          </MUISelect>
        )}
      />
      <Divider />
      <PSRDropdownControl
        name="psrType"
        textValue="PSR Type"
        psrProtocolData={getEmptyValue(psrTypeData)}
        handleDropdown={handleChange}
        value={psrType}
        validators={['required']}
        errorMessages={['Required Field']}
        isDisabled={isDisabled === true}
      />
      <Divider />
      <PSRDatePickerControl
        title="Required By Date"
        textValue="Required By Date"
        dateField={classes.dateField}
        value={getEmptyValue(requiredByDate)}
        name="requiredByDate"
        handleDateChange={handleDateChange('requiredByDate')}
        validators={psrType !== 'COLLECT' && ['required']}
        errorMessages={['Required Field']}
      // isDisabled={verifiedBy !== 'SITE_DTL'}
      />
      <Divider />
      <FormViewContent
        key={`${verifiedBy}`}
        primaryText="Number of Persons"
        secondaryText={(
          <Tooltip
            tooltipplacementbottom="true"
            title={
              verifiedBy !== 'PERSON_ATTRIBUTE'
                ? 'This only applies to Person Attributes'
                : 'Select Number of Persons'
            }
            aria-label="Number of Persons"
            style={{ width: '100%' }}
          >
            <MUISelect
              value={numPersonRqdFulfillPsr}
              name="numPersonRqdFulfillPsr"
              className={classes.editable}
              title="Number of Persons"
              disabled={(verifiedBy !== 'PERSON_ATTRIBUTE') || (verifiedBy === 'SITE_DTL')}
              onChange={handleChange}
              errorMessages={verifiedBy === 'PERSON_ATTRIBUTE' && ['Required Field']}
              validators={verifiedBy === 'PERSON_ATTRIBUTE' ? ['required'] : []}
            >
              {Array(10).fill(0).map((d, i) => {
                const value = `${i + 1}`;
                return (<ListItem button value={value} key={value}>
                  <ListItemText primary={value} />
                </ListItem>);
              })}
              <ListItem button value="All" key="All">
                <ListItemText primary="All" />
              </ListItem>
            </MUISelect>
          </Tooltip>
        )}
      />
      <Divider />
      <FormViewContent
        primaryText="Group Eval"
        secondaryText={(
          <MUISelect
            value={isEvalByGroup === true}
            name="isEvalByGroup"
            className={classes.editable}
            // validators={["required"]}
            // errorMessages={["TRIAD Protocol is required"]}
            title="Group Eval"
            isDisabled={isDisabled === true}
            onChange={handleChange}
          >
            <ListItem button value key="groupEvalYes">
              <ListItemText primary="Yes" />
            </ListItem>
            <ListItem button value={false} key="groupEvalNo">
              <ListItemText primary="No" />
            </ListItem>
          </MUISelect>
        )}
      />
      <Divider />
      <Divider />
      <PSRDropdownControl
        name="esysStatus"
        value={getEmptyValue(esysStatus)}
        textValue="Status"
        psrProtocolData={statusData}
        handleDropdown={handleChange}
        validators={['required']}
        errorMessages={['Required Field']}
        isDisabled={isDisabled === true}
      />
      <Divider />
      <List
        subheader={(
          <ListSubHeader flex>
            <Typography data-id="ctsuProcessInstructions" inline className="font-btn color-dark-blue font-bold">
              CTSU Processing Instructions
            </Typography>
          </ListSubHeader>
        )}
      >
        <PSRDropdownControl
          name="source"
          value={getEmptyValue(source)}
          psrProtocolData={protocolPSRSource}
          textValue="Source"
          handleDropdown={handleChange}
          isDisabled={verifiedBy === 'SITE_DTL'}
        />
        <Divider />
        <PSRMultilineTextControl
          name="websiteDescription"
          value={getEmptyValue(websiteDescription)}
          textpsrField={textpsrField}
          primaryText="Website Description"
          onChange={handleChange}
          validators={websiteDescription ? ['maxStringLength:4000'] : []}
          errorMessages={['Crossed the maximum limit of 4000 characters']}
          isDisabled={verifiedBy === 'SITE_DTL'}
        />
        <Divider />
        <PSRMultilineTextControl
          name="websiteInstructions"
          value={getEmptyValue(websiteInstructions)}
          textpsrField={textpsrField}
          primaryText="Website Instructions"
          onChange={handleChange}
          validators={websiteInstructions ? ['maxStringLength:4000'] : []}
          errorMessages={['Crossed the maximum limit of 4000 characters']}
          isDisabled={verifiedBy === 'SITE_DTL'}
        />
        <Divider />
        <PSRMultilineTextControl
          name="ctsuGeneralInstructions"
          value={getEmptyValue(ctsuGeneralInstructions)}
          textpsrField={textpsrField}
          primaryText="CTSU Processing Instructions"
          onChange={handleChange}
          validators={['maxStringLength:4000']}
          errorMessages={['Crossed the maximum limit of 4000 characters']}
          isDisabled={verifiedBy === 'SITE_DTL'}
        />
        <Divider />
        <PSRMultilineTextControl
          name="comments"
          value={getEmptyValue(comments)}
          textpsrField={textpsrField}
          primaryText="Comments"
          onChange={handleChange}
          validators={['maxStringLength:100']}
          errorMessages={['Crossed the maximum limit of 100 characters']}
          isDisabled={verifiedBy === 'SITE_DTL'}
        />
      </List>
      <Divider />
      <List
        subheader={(
          <ListSubHeader flex>
            <Typography data-id="contactInfoTitle" inline className="font-btn color-dark-blue font-bold">
              Contact Information
            </Typography>
          </ListSubHeader>
        )}
      >
        <FormViewContent
          primaryText="Name"
          secondaryText={(
            <MUITextBox
              className={textpsrField}
              variant="outlined"
              title="Name"
              validators={contactName ? ['maxStringLength:4000'] : []}
              errorMessages={['Crossed the maximum limit of 4000 characters']}
              id="outlined-multiline-static"
              name="contactName"
              value={getEmptyValue(contactName)}
              onChange={handleChange}
              disabled={verifiedBy === 'SITE_DTL'}
            />
          )}
        />
        <Divider />
        <FormViewContent
          primaryText="Phone"
          secondaryText={(
            <MUITextBox
              title="Phone"
              className={textpsrField}
              variant="outlined"
              validators={contactPhone ? ['maxStringLength:4000'] : []}
              errorMessages={['Crossed the maximum limit of 4000 characters']}
              id="outlined-multiline-static"
              name="contactPhone"
              value={getEmptyValue(contactPhone)}
              onChange={handleChange}
              disabled={verifiedBy === 'SITE_DTL'}
            />
          )}
        />
        <Divider />
        <FormViewContent
          primaryText="Email"
          secondaryText={(
            <MUITextBox
              title="Phone"
              className={textpsrField}
              variant="outlined"
              validators={contactEmail ? ['maxStringLength:4000'] : []}
              errorMessages={['Crossed the maximum limit of 4000 characters']}
              id="outlined-multiline-static"
              name="contactEmail"
              value={getEmptyValue(contactEmail)}
              onChange={handleChange}
              disabled={verifiedBy === 'SITE_DTL'}
            />
          )}
        />
        <Divider />
        <PSRMultilineTextControl
          name="distributionEmail"
          value={getEmptyValue(distributionEmail)}
          textpsrField={textpsrField}
          primaryText="Distribution List"
          onChange={handleChange}
          validators={distributionEmail ? ['maxStringLength:4000'] : []}
          errorMessages={['Crossed the maximum limit of 4000 characters']}
          isDisabled={verifiedBy === 'SITE_DTL'}
        />
        {!psrId && loadAffiliation()}
      </List>
      <CTSUCardActions
        clearClick={clearHandler}
        cancelClick={closeEditPSR}
        disabled={_.isEqual(state, data)}
        disableSave={saveFlag}
      />
    </ValidatorForm>
  );
};

export const EditPSRDetails = withStyles(styles)(
  compose(
    withState('state', 'setState', {}),
    withChangeHandlers,
    withHandlers({
      clearHandler: props => event => {
        const { setState, data } = props;
        setState({ ...data });
      },
      handleCheckValueChange: props => event => {
        const { state, setState } = props;
        setState(
          { ...state, code: event ? event.value : '', description: event ? event.desc : '' }
        );
      },
      handleVersionChange: props => event => {
        const { state, setState, versions } = props;
        const verObj = versions.data.find(ver => ver.verId === event.target.value);
        setState({
          ...state,
          forVersionDate: verObj.versionDate,
          verId: event.target.value
        });
      },
      handleVerfiedByChange: props => event => {
        const { isNewpsr, state, setState } = props;
        if (isNewpsr === true && event.target.value === 'LINKED_ORG_PROVIDER') {
          setState({
            ...state,
            verifiedBy: event.target.value,
            description: 'RT Provider Linked to Site',
            code: 'LINKED_ORG_PROVIDER',
            affiliations: []
          });
        } else if (isNewpsr === true && event.target.value !== 'LINKED_ORG_PROVIDER') {
          setState({
            ...state,
            verifiedBy: event.target.value,
            description: '',
            affiliations: []
          });
        } else {
          state[event.target.name] = event.target.value;
          setState({
            ...state,
            affiliations: []
          });
        }
      }
    })
  )(EditPsrDetails)
);


EditPSRDetails.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]),
  versions: PropTypes.oneOfType([PropTypes.object]),
  protocolNumber: PropTypes.string.isRequired,
  savePSRInfo: PropTypes.func.isRequired,
  closeEditPSR: PropTypes.func.isRequired
};

EditPSRDetails.defaultProps = {
  data: null,
  versions: {}
};
